/* NailSafe — interacciones. Vanilla, sin librerías. Cada init comprueba si su elemento existe. */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Reveals al hacer scroll (un único observer) ---------- */
  var io = null;
  function observe(root) {
    var els = (root || document).querySelectorAll('.ns-reveal, .ns-media--mask, .ns-steps__progress');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-in'); });
      return;
    }
    if (!io) {
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    }
    els.forEach(function (el) { if (!el.classList.contains('is-in')) io.observe(el); });
  }

  /* ---------- Hero: entrada + parallax suave (solo escritorio) ---------- */
  function initHero(root) {
    (root || document).querySelectorAll('.ns-hero').forEach(function (hero) {
      requestAnimationFrame(function () { requestAnimationFrame(function () { hero.classList.add('is-loaded'); }); });
      var img = hero.querySelector('.ns-hero__bg');
      var strength = parseFloat(hero.getAttribute('data-parallax') || '0');
      if (!img || reduce || !strength || window.innerWidth < 990) return;
      var ticking = false;
      function update() {
        var r = hero.getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight) {
          img.style.transform = 'translate3d(0,' + (-r.top * strength / 100).toFixed(1) + 'px,0)';
        }
        ticking = false;
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }, { passive: true });
    });
  }

  /* ---------- Acordeones con animación de cierre ---------- */
  function initAccordions(root) {
    (root || document).querySelectorAll('.ns-acc details').forEach(function (d) {
      if (d.dataset.nsInit) return;
      d.dataset.nsInit = '1';
      var summary = d.querySelector('summary');
      summary.addEventListener('click', function (e) {
        if (!d.open || reduce) return;
        e.preventDefault();
        d.classList.add('is-closing');
        var panel = d.querySelector('.ns-acc__panel');
        panel.style.gridTemplateRows = '0fr';
        setTimeout(function () { d.open = false; panel.style.gridTemplateRows = ''; d.classList.remove('is-closing'); }, 450);
      });
    });
  }

  /* ---------- Galería de producto ---------- */
  function initGallery(root) {
    (root || document).querySelectorAll('[data-ns-gallery]').forEach(function (gal) {
      var track = gal.querySelector('.ns-gal__track');
      var slides = gal.querySelectorAll('.ns-gal__slide');
      var thumbs = gal.querySelectorAll('.ns-gal__thumb');
      var dots = gal.querySelectorAll('.ns-gal__dots span');
      if (!track || slides.length < 1) return;
      var i = 0;
      var mobile = window.matchMedia('(max-width: 749px)');
      function go(n) {
        i = (n + slides.length) % slides.length;
        if (mobile.matches) {
          track.scrollTo({ left: slides[i].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
        } else {
          track.style.transform = 'translate3d(' + (-100 * i) + '%,0,0)';
        }
        mark();
      }
      function mark() {
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
        dots.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { go(k); }); });
      var prev = gal.querySelector('[data-prev]'), next = gal.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', function () { go(i - 1); });
      if (next) next.addEventListener('click', function () { go(i + 1); });
      track.addEventListener('scroll', function () {
        if (!mobile.matches) return;
        var paso = slides.length > 1 ? (slides[1].offsetLeft - slides[0].offsetLeft) : track.clientWidth;
        var n = Math.min(slides.length - 1, Math.round(track.scrollLeft / paso));
        if (n !== i) { i = n; mark(); }
      }, { passive: true });
      gal.goToMedia = function (mediaId) {
        slides.forEach(function (s, k) { if (s.getAttribute('data-media-id') === String(mediaId)) go(k); });
      };
      mark();
    });
  }

  /* ---------- Variantes, cantidad y barra fija de compra ---------- */
  function initProduct(root) {
    (root || document).querySelectorAll('[data-ns-product]').forEach(function (wrap) {
      var dataEl = wrap.querySelector('script[data-ns-variants]');
      var form = wrap.querySelector('form[action*="/cart/add"]');
      if (!form) return;
      var idInput = form.querySelector('input[name="id"]');
      var btns = wrap.querySelectorAll('[data-ns-add]');
      var priceEl = wrap.querySelector('[data-ns-price]');
      var compareEl = wrap.querySelector('[data-ns-compare]');
      var saveEl = wrap.querySelector('[data-ns-save]');
      var stickyPrice = document.querySelector('[data-ns-sticky-price]');
      var fmt = wrap.getAttribute('data-money-format') || '{{amount_with_comma_separator}} €';
      var soldText = wrap.getAttribute('data-sold-text') || 'Agotado';
      var addText = wrap.getAttribute('data-add-text') || 'Añadir al carrito';

      function money(cents) {
        var v = (cents / 100).toFixed(2);
        var parts = v.split('.');
        var withComma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
        var withDot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
        return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withComma)
                  .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, parts[0])
                  .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
                  .replace(/\{\{\s*amount\s*\}\}/, withDot);
      }

      if (dataEl) {
        var variants = [];
        try { variants = JSON.parse(dataEl.textContent); } catch (e) {}
        wrap.querySelectorAll('.ns-opt input').forEach(function (inp) {
          inp.addEventListener('change', function () {
            var chosen = [];
            wrap.querySelectorAll('.ns-opt').forEach(function (fs) {
              var c = fs.querySelector('input:checked');
              chosen.push(c ? c.value : null);
            });
            var v = variants.find(function (x) {
              return x.options.every(function (o, k) { return o === chosen[k]; });
            });
            if (!v) {
              btns.forEach(function (b) { b.disabled = true; b.querySelector('span').textContent = soldText; });
              return;
            }
            idInput.value = v.id;
            if (priceEl) priceEl.textContent = money(v.price);
            if (stickyPrice) stickyPrice.textContent = money(v.price);
            if (compareEl) {
              var on = v.compare_at_price && v.compare_at_price > v.price;
              compareEl.textContent = on ? money(v.compare_at_price) : '';
              compareEl.hidden = !on;
              if (saveEl) {
                saveEl.hidden = !on;
                if (on) saveEl.textContent = '-' + Math.round((1 - v.price / v.compare_at_price) * 100) + '%';
              }
            }
            btns.forEach(function (b) {
              b.disabled = !v.available;
              b.querySelector('span').textContent = v.available ? addText : soldText;
            });
            var url = new URL(window.location.href);
            url.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', url.toString());
            if (v.featured_media) {
              var gal = document.querySelector('[data-ns-gallery]');
              if (gal && gal.goToMedia) gal.goToMedia(v.featured_media.id);
            }
          });
        });
      }

      var qty = wrap.querySelector('.ns-qty input');
      wrap.querySelectorAll('[data-ns-packs] input').forEach(function (r) {
        r.addEventListener('change', function () { if (qty) qty.value = r.value; });
      });
      wrap.querySelectorAll('.ns-qty button').forEach(function (b) {
        b.addEventListener('click', function () {
          var n = parseInt(qty.value || '1', 10) + (b.hasAttribute('data-plus') ? 1 : -1);
          qty.value = Math.max(1, n);
          var match = wrap.querySelector('[data-ns-packs] input[value="' + qty.value + '"]');
          wrap.querySelectorAll('[data-ns-packs] input').forEach(function (x) { x.checked = x === match; });
        });
      });

      /* Barra fija en móvil: aparece cuando el botón principal sale de pantalla */
      var sticky = document.querySelector('.ns-sticky-buy');
      var mainBtn = wrap.querySelector('.ns-buy__row');
      if (sticky && mainBtn && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (es) {
          es.forEach(function (e) { sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0); });
        }).observe(mainBtn);
        var sb = sticky.querySelector('button');
        if (sb) sb.addEventListener('click', function () { form.requestSubmit ? form.requestSubmit() : form.submit(); });
      }
    });
  }

  function initAll(root) {
    observe(root);
    initHero(root);
    initAccordions(root);
    initGallery(root);
    initProduct(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else { initAll(); }

  /* Editor de Shopify: reactivar al añadir/editar secciones */
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
